import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import {
  packageMissingPaymentMethod,
  packageOrderNeedsPayment,
  packagePaymentMethodExpired,
} from "@whoosh/features/src/Packages";

import { usePackageNeedsAttention_memberPackage$key } from "./__generated__/usePackageNeedsAttention_memberPackage.graphql";

export const usePackageNeedsAttention = (
  memberPackageRef?: usePackageNeedsAttention_memberPackage$key | null
) => {
  const memberPackage = useFragment(
    usePackageNeedsAttentionFragmentString,
    memberPackageRef
  );

  const orders =
    memberPackage?.orders?.edges?.flatMap((edge) =>
      edge?.node ? [edge.node] : []
    ) || [];

  const packageNeedsPayment = memberPackage
    ? orders.some((order) => {
        if (!order) return false;
        return packageOrderNeedsPayment(order);
      })
    : false;

  const paymentMethodMissing = packageMissingPaymentMethod(memberPackage);
  const paymentMethodExpired = packagePaymentMethodExpired(memberPackage);

  return packageNeedsPayment || paymentMethodMissing || paymentMethodExpired;
};

const usePackageNeedsAttentionFragmentString = graphql`
  fragment usePackageNeedsAttention_memberPackage on MemberPackage {
    id
    orders {
      edges {
        node {
          ...packageOrderNeedsPayment_order
        }
      }
    }
    ...packageMissingPaymentMethod_memberPackage
    ...packagePaymentMethodExpired_memberPackage
  }
`;
